export { ListPage, type ListPageProps } from "./list-page";
export { DetailPage, type DetailPageProps, type DetailTab } from "./detail-page";
export { FormPage, type FormPageProps } from "./form-page";
export { DashboardPage, type DashboardPageProps } from "./dashboard-page";
export { WizardPage, type WizardPageProps, type WizardStep } from "./wizard-page";
export { SettingsPage, type SettingsPageProps, type SettingsSection } from "./settings-page";
